/* global USER_URL */

import BaseApi from 'common/api/base';

export default class UserApi extends BaseApi {
  constructor() {
    super();
    this.baseUrl = USER_URL;
  }

  me(withRoles = false) {
    if (!withRoles) {
      return this.fetch('GET', 'me');
    }
    return this.fetch('GET', 'me?roles=true');
  }

  fetchUserAgencies({product}) {
    return this.fetch('GET', `me/agencies?product=${product}`);
  }

  // eslint-disable-next-line no-empty-pattern
  fetchRides({}, cursor) {
    const query = cursor ? `?page.cursor=${cursor}` : '';
    return this.fetch('GET', `me/rider/rides${query}`);
  }

  fetchRiderServiceLimits({serviceId, timestamp}) {
    const query = timestamp ? `?timestamp=${encodeURIComponent(timestamp)}` : '';
    return this.fetch('GET', `me/rider/services/${serviceId}/limits${query}`);
  }

  // eslint-disable-next-line no-empty-pattern
  fetchRiderAddresses({}, cursor) {
    const query = cursor ? `?page.cursor=${cursor}` : '';
    return this.fetch('GET', `me/rider/addresses${query}`);
  }

  saveRiderAddress(address) {
    const endpoint = `me/rider/addresses/${address.address_id || ''}`;
    return this.fetch(address.address_id ? 'PUT' : 'POST', endpoint, address);
  }

  deleteRiderAddress(addressId) {
    return this.fetch('DELETE', `me/rider/addresses/${addressId}`);
  }

  findUser(query) {
    return this.fetch('GET', `users?q=${encodeURIComponent(query)}`);
  }

  createRider(rider) {
    return this.fetch('POST', 'users', rider);
  }
}



// WEBPACK FOOTER //
// ./src/common/api/UserApi.js